import axios from 'axios'
import { Message } from 'element-ui'
import cookies from './cookie'
let instance = axios.create({
	timeout: 500000
})

instance.interceptors.request.use(
	config => {
		config.headers.token = cookies.get('token')
		return config
	},
	err => {
		return Promise.reject(err)
	}
)
instance.interceptors.response.use(
	response => {
		if (Number(response.data.code) !== 200) {
			let message = response.data.msg || '失败'
			Message.error(message)
			return response
		}
		return response
	},
	error => {
		return Promise.reject(error)
	}
)
export default instance
